<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00010"><span class="calibre1" id="Page_90" title="90"></span><span>Afternoon Session</span></h2>
<p class="pindent">MARSHAL: If it please the Tribunal, may I report that the
Defendant Streicher will be absent from this session of Court.</p>
<p class="pindent">THE PRESIDENT: The Tribunal rules that evidence as to the
injustice of the Versailles Treaty or whether it was made under
duress is inadmissible, and it therefore rejects Volume 3 of the
documents on behalf of the Defendant Hess.</p>
<p class="pindent">DR. SEIDL: Mr. President, Your Honors. Since Volume 3 of the
document book for the Defendant Rudolf Hess is not admissible
as documentary evidence, I am, so far as the submission of documents
is concerned, at the end of my submission of evidence. Now,
we are further concerned only with the affidavit of Ambassador
Gaus, which I have already submitted, and I ask you not to decide
on the admissibility of this document until I have had opportunity
to present arguments on the relevance of it and of the secret
treaty. But I should like to point out that with this affidavit only
the facts and the contents of this secret treaty are to be proved;
and therefore I shall read only excerpts from it, so that other
events and the history prior to the treaty are not to be demonstrated
by me.</p>
<p class="pindent">THE PRESIDENT: Dr. Seidl, we understand that this affidavit
of the witness Gaus is now being translated and is going to be
submitted to the various prosecutors. They will then inform us
of their position, and we shall be able to see whether it is admissible
or not, and the Prosecution will likewise be able to tell us
whether they want to have the Ambassador here for the purpose
of cross-examining him.</p>
<p class="pindent">DR. SEIDL: Yes.</p>
<p class="pindent">THE PRESIDENT: So we must postpone that until we get the
translations.</p>
<p class="pindent">DR. SEIDL: I had then the further intention of calling the
defendant himself as a witness. In view of his attitude as to the
question of the competency of this Court, he has asked me, however,
to dispense with this procedure. I therefore forego the testimony
of the defendant as a witness and have no further evidence to
put in at this point.</p>
<p class="pindent">THE PRESIDENT: Thank you.</p>
<p class="pindent">Then the Tribunal will now deal with the case against the
Defendant Ribbentrop.</p>
<p class="pindent">DR. HORN: Your Lordship, Your Honors, my client, Joachim
von Ribbentrop, had instructed me to make the following statement
for him at the beginning of the evidence:
<span id="Page_91" title="91"></span></p>
<div class="blockquote">
<p class="calibre3">“As Foreign Minister for the Reich, I had to carry through
the directions and orders of Adolf Hitler concerning foreign
policy. For the measures of foreign policy undertaken by
me I accept full responsibility.”</p>
</div>
<p class="pindent">THE PRESIDENT: Dr. Horn, I thought defendants’ counsel
knew that the rule which we have laid down is that at this stage
no speeches shall be made, but that the evidence should be called,
the oral evidence should be called, and the documents should be
briefly referred to and offered in evidence. Did you not understand
that?</p>
<p class="pindent">DR. HORN: I did not know, Mr. President, that one might not
submit a statement on behalf of his client.</p>
<p class="pindent">THE PRESIDENT: Well, the Tribunal has laid down on several
occasions, I think, verbally and certainly once in writing, that no
speeches can be made now, but that speeches can be made at
the time laid down in the Charter. The present opportunity is
for all evidence to be given and for documents to be offered in
evidence, with such explanatory observations upon the documents
as may be necessary.</p>
<p class="pindent">DR. HORN: The former Foreign Minister for the Reich, Joachim
von Ribbentrop, is, according to the general Indictment and
according to the trial brief of the British Delegation and the verbally
presented special charges, held responsible for all crimes cited in
Article 6 of the Charter of the International Military Tribunal.</p>
<p class="pindent">Sir David Maxwell-Fyfe, in the session of the International
Military Tribunal of 8 January 1946, described the facts of the
case against my client as follows:</p>
<p class="pindent">Firstly, the using of his offices and of his personal influence
and intimate connection with Hitler to facilitate the seizure of
power through the NSDAP and the preparation of wars.</p>
<p class="pindent">Secondly, the participation in the political planning, and
preparation of the National Socialist Conspiracy for Wars of
Aggression...</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, are you again making a speech or
what are you doing?</p>
<p class="pindent">DR. HORN: No, Mr. President, I am just enumerating on one
page how I plan to arrange my evidence, and I ask to be allowed
to divide it in this way.</p>
<p class="pindent">THE PRESIDENT: Very well.</p>
<p class="pindent">DR. HORN: Secondly, Sir David Maxwell-Fyfe adduced the participation
in the political planning and preparation of the National
Socialist conspirators for aggressive war and the wars in violation
of international treaties. He accordingly bears the responsibility
<span id="Page_92" title="92"></span>
for the execution of the foreign policy planned by the political
conspirators.</p>
<p class="pindent">Thirdly, participation in and approval of Crimes against Peace,
War Crimes, and Crimes against Humanity, especially crimes
against persons and property in the occupied territories.</p>
<p class="pindent">The Defendant Von Ribbentrop has declared himself not guilty
of all crimes charged against him. To refute the charges made
against him, I will begin now my presentation of evidence.</p>
<p class="pindent">The honorable prosecutor at the beginning of his statements
quoted from Exhibit Number USA-5, Document Number 2829-PS,
and brought out that the Defendant Von Ribbentrop was an
SS Obergruppenführer. The honorable prosecutor asserted that this
rank was not an honorary one. In opposition to this, the defendant
asserts that the rank of an SS Gruppenführer and later of Obergruppenführer,
bestowed by Hitler, was bestowed upon him only
on an honorary basis, because Hitler wished that the members
of the Government should appear on official occasions in uniform,
and the rank of an SS Gruppenführer appeared in keeping with
the official position of the defendant. The defendant neither served
in the SS nor led an SS unit. Neither did he have any adequate
military training and preparation for this high military position.</p>
<p class="pindent">To demonstrate this I will submit evidence from the defendant
himself as a witness.</p>
<p class="pindent">The Prosecution has asserted that Von Ribbentrop, after the
taking over of power, for a short period of time was adviser of
the Party on foreign political matters. This assertion is refuted
by Document 2829-PS which is contained in the document book
in the hands of the Tribunal. I will read Paragraph 3, where
it says:</p>
<div class="blockquote">
<p class="calibre3">“Foreign Policy Collaborator to the Führer, 1933-1938.”</p>
</div>
<p class="noindent">This is the first document of the Ribbentrop document book.
According to it, in the years 1933 to 1938 Von Ribbentrop was
only Hitler’s adviser on foreign political questions. With reference
to Document D-472, Exhibit Number GB-130, the second document
in the Document Book Ribbentrop, which concerns an excerpt
from the International Biographical Archives, the honorable prosecutor
claimed that the defendant even before 1932 worked for
the NSDAP, after he had entered the Party service in 1930. The
Prosecution cites Paragraph II, Lines 6-9, of this document,
which says:</p>
<div class="blockquote">
<p class="calibre3">“Following up his connection with foreign countries, he
established new relations with England and France; having
been in the service of the NSDAP since 1930, he knew how
to extend them to political circles.”</p>
</div>
<p class="pindent"><span id="Page_93" title="93"></span></p>
<p class="pindent">The statement is not correct. The defendant was until 1932 not
a member of any political party in Germany, particularly not of
the NSDAP. As far as his political views were concerned, he
leaned toward the Deutsche Volkspartei—that is the party of
Stresemann.</p>
<p class="pindent">In the year 1932 the defendant came to know Hitler personally.
His views on domestic and foreign political matters brought him...</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, I do not want to interrupt you
unnecessarily, but I do not understand what you are doing now.
You seem to me to be stating a part of the evidence which presumably
the Defendant Von Ribbentrop will give, and, if so, when
he gives it it will be cumulative to your statement. Also, you
seem to be referring to documents which have been produced by
the Prosecution and answering them yourself. Well, that is not
what the Tribunal desires at this stage. It quite understands that
at the appropriate time you will make whatever argument you
think right with reference to the evidence which has been brought
forward, on behalf of the Defendant Von Ribbentrop. But, as
I have already said—I thought quite clearly—what the Tribunal
wants done now is to hear all the evidence on behalf of Von Ribbentrop
and to have offered in evidence the documents upon which
you will rely, with any short explanatory statement as to the
meaning of the documents. And if there is any part of a document
which has been produced by the Prosecution but not cited by them
which you think it necessary to refer to, as explanatory of the
part of the document which has been used by them, then you are
at liberty to put in, to offer in evidence that part of the document
with any short explanatory words that you wish. But I do not
understand what you are doing now except making a speech.</p>
<p class="pindent">DR. HORN: Mr. President, I was using the opposing fact which
I wish to present against the claims of the Prosecution, because
according to my information and according to my documents,
they do not correspond to the facts. As far as the establishment
of Point 1 of what Mr. President has just said, I would like to
state the following: The health of the Defendant Von Ribbentrop
is quite poor at present. This morning the doctor told me that
Ribbentrop is suffering from so-called vasomotor disturbances in
his speech. I wanted to take a part of his evidence statement from
my client by making a statement of it here and thus showing the
position of the defendant to the Tribunal. I do not know whether
the Defendant Von Ribbentrop, in view of his present state of
health, that is, his impediment of speech, could make these explanations
as briefly as I myself can. Then, when the defendant is in
the box, he needs only to confirm these statements under oath.
<span id="Page_94" title="94"></span></p>
<p class="pindent">THE PRESIDENT: If the Defendant Von Ribbentrop is too ill
to give evidence today, then he must give evidence on some future
occasion. If you have any oral witnesses to call other than the
Defendant Von Ribbentrop, then they can give evidence today; and
with reference to the documentary evidence, it is perfectly simple
for you to offer those documents in evidence in the way that it
was done by Dr. Stahmer, in the way that it was done by Dr. Seidl,
and the way in which the Tribunal have explained over and
over again.</p>
<p class="pindent">DR. HORN: I had intended to submit documents first and not
to call my witnesses until later. As far as Von Ribbentrop is concerned,
I have learned that his condition has become constantly
worse. I do not know therefore whether at the end of the presentation
of evidence I will be in a position to summon the Defendant
Von Ribbentrop; but I must be prepared for the possibility
that I might not be able to call him. And otherwise I am concerned
with only a very few very general points for rectification.</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, you cannot give evidence at any
rate and if you cannot call Von Ribbentrop, then you must, if it
is possible to do so, call some other witnesses who will give the
evidence which he would have given. If, unfortunately, it is not
possible to do so, then his case may suffer; but the Tribunal will
give every possible facility for his being called at any stage. If
he is in fact so ill, as you suggest, that he cannot give evidence,
then his evidence may be put off until the end of the defendants’
case, subject of course to a proper medical certificate being produced.</p>
<p class="pindent">DR. HORN: If the Court wants then later to hear the defendant,
I will postpone the matter with the request that if I cannot
hear him, that is, cannot hear him fully—for I emphasize again,
there is a speech disturbance—then he can at least confirm the
evidence as a witness.</p>
<p class="pindent">THE PRESIDENT: You may call any of the witnesses; the
Tribunal has not laid down that the defendant must be called first.
You have applied for eight witnesses, I think, in addition to the
defendant and you can call any of them or you can deal with
your documents, but whichever you do, you must do it in the way
which the Tribunal has ordered.</p>
<p class="pindent">DR. HORN: Then, I will turn now to the occupation of the
Rhineland.</p>
<p class="pindent">On 27 February 1936, there was ratified between the French
Republic and the Soviet Union a mutual-assistance pact, the content
of which clearly violated the Locarno Treaty and the covenant of
the League of Nations, and was solely directed against Germany.
At the same time...
<span id="Page_95" title="95"></span></p>
<p class="pindent">THE PRESIDENT: Dr. Horn, you have just said that something
or other is against international law. Now, that is not a reference
to any document which you are offering in evidence, nor is it any
comment upon the production of oral evidence. If you have a
document to offer, kindly offer it and then make any necessary
explanatory remarks.</p>
<p class="pindent">DR. HORN: Then, I wanted next to refer to Document Number 1
in the Document Book Ribbentrop. We are concerned with a
memorandum of the German Government to the signatory powers
of the Locarno Pact, of 7 March 1936.</p>
<p class="pindent">THE PRESIDENT: Which page is that?</p>
<p class="pindent">DR. HORN: That is on Page 6 of the document book. In
explanation I may add that this memorandum was submitted to
the signatory powers, because between the French Government
and the Republic of the Soviet Union a treaty of mutual assistance
had been ratified and at the same time, the German Foreign Office
received knowledge of a plan which the French General Staff had
worked out and which arranged that the French Army was to
advance along the line of the Main, so that North and South
Germany in this way would be separated, and even to join hands
with the Russian Army across Czechoslovakia.</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, for the formality of the record,
it is necessary to offer each document in evidence and the document
should be given a number. You have not yet offered any of
these documents in evidence or given them any numbers, so far
as I know.</p>
<p class="pindent">DR. HORN: I gave this document the number, Ribbentrop
Exhibit Number 1. The number is in the upper right hand corner
of the document.</p>
<p class="pindent">THE PRESIDENT: Very well.</p>
<p class="pindent">DR. HORN: And I ask—perhaps I may say this in order to
save time—I ask that all these documents quoted as Ribbentrop
exhibit number be accepted in evidence.</p>
<p class="pindent">THE PRESIDENT: Very well, and in the order in which you
quote them?</p>
<p class="pindent">DR. HORN: Yes, Mr. President.</p>
<p class="pindent">THE PRESIDENT: They will be numbered that way. Very well.</p>
<p class="pindent">DR. HORN: As to the particulars just submitted on the reason
for this memorandum being lodged, and as evidence of the fact just
cited regarding the arrangement of the French General Staff, I
will call Von Neurath as a witness. I will question him on this
one point, when he is called into the box. In order to justify the
German view, which is contained in the memorandum and which
<span id="Page_96" title="96"></span>
consists in the fact that the Locarno Pact and the League of
Nations covenant were considered infringed upon, I would like to
refer to Page 3 of the document and wish to quote the following—this
is on Page 8 of the document book:</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, was this document Exhibit Number
Ribbentrop-1, one of the documents for which you applied and
which you were allowed in the applications?</p>
<p class="pindent">DR. HORN: Yes, Mr. President. This document is concerned with
excerpts from the <span class="it1">Dokumente der Deutschen Politik</span> (<span class="it1">Documents
of German Politics</span>), Volume 4.</p>
<p class="pindent">I want to stress that this collection of documents was granted
to me at the same time as the two evidence books.</p>
<p class="pindent">THE PRESIDENT: The Tribunal would like to see the original
document.</p>
<p class="pindent">DR. HORN: Mr. President, we are not in a position to present
original documents, since the Foreign Office was confiscated by
the victorious powers and with it a great part of the documents.
Then I would have to make an application now that the signatory
powers concerned produce these original documents, for we simply
are not able to. We can only refer to document collections.</p>
<p class="pindent">THE PRESIDENT: Where does the copy come from?</p>
<p class="pindent">DR. HORN: This copy, Mr. President, is from the <span class="it1">Dokumente
der Deutschen Politik</span>, Volume 4, as is shown in the document
book which the President has before him. The document is found
on Page 123 of this document collection.</p>
<p class="pindent">I should like, Mr. President, to add an explanatory remark: If
the Court is interested in seeing the original, I should have to have
the collection, which is up in the document room now, brought
down. It is in German, and I do not believe that it would be
of any value to the Tribunal at this time. May I mention further...</p>
<p class="pindent">THE PRESIDENT: You see, Dr. Horn, as a matter of formality
and certainty, the Tribunal ought to have in its record every
document which forms part of the record, whether it is an original
or whether it is a copy; and whatever the document is that is
offered in evidence, it ought to be handed in to the Tribunal and
kept by the Tribunal. It ought to be put in evidence, offered in
evidence, and handed to the General Secretary or his representative,
and then the Tribunal has a full record of every document
which is in evidence.</p>
<p class="pindent">But we cannot have documents such as this, which is a mere
copy of the original document which ought to be offered in
evidence. If it is at the Information Center, then it is quite capable
of being produced here.
<span id="Page_97" title="97"></span></p>
<p class="pindent">DR. HORN: Mr. President, the Court decided that we are justified
in copying documents and certifying to the authenticity in
order that these documents may be submitted as evidence to the
Tribunal. Therefore, we have compared every document with the
original we had on hand, or with the printed copy of the document
and at the end of the document we attested the authenticity of
the copy. This document, certified with my own signature, is in
the hands of the Tribunal, I believe in five copies.</p>
<p class="pindent">THE PRESIDENT: Dr. Horn—Yes, Mr. Dodd.</p>
<p class="pindent">MR. DODD: We thought that we might be helpful. We say
that we are willing to accept this quotation from the volume
referred to, and I do think that we did put in some documents
ourselves and asked the Court’s indulgence at the time in something
of the same fashion.</p>
<p class="pindent">I think the Court, if I may suggest respectfully, might take this
document on that same basis.</p>
<p class="pindent">I have conferred only with Sir David, but I feel quite sure that
our French and Russian colleagues will agree as well.</p>
<p class="pindent">THE PRESIDENT: I think, Mr. Dodd, the point is—and, of
course, it is probably only a formal point—that the only document
which is offered in evidence or put in evidence is a copy which
does not contain Dr. Horn’s signature and therefore there is nothing
to show that it is in fact a true copy. Of course, if we had had
Dr. Horn’s signature, we would be prepared to accept that it was
a true copy of the original. What we have before us is a mere
mimeograph, I suppose, of some document which has not been
produced to us.</p>
<p class="pindent">MR. DODD: Very well, Your Honor. I have not had an opportunity
to examine it carefully. We did not get these documents,
by the way, until pretty late last night. We have not had the
usual period of time to examine it, but in any event, I have suggested
it might go in, and if Dr. Horn would verify it, as suggested by
the President, and later furnish the original copy, it might be
all right.</p>
<p class="pindent">THE PRESIDENT: That would be all right, certainly.</p>
<p class="pindent">Dr. Horn, you understand what I mean. If you will produce
to us at some future date the actual document which you signed
yourself, to show that it was a true copy, that will be quite
satisfactory.</p>
<p class="pindent">DR. HORN: Mr. President, in the entire document book there
is no document which I have not signed and given in five copies
to be translated. Of course, I cannot also sign all the translations.
This document which is contained in the document book submitted
to the President has my signature in the German text.
<span id="Page_98" title="98"></span></p>
<p class="pindent">THE PRESIDENT: You mean that you have handed your
documents in to be translated, in German, with your signature
at the bottom, saying it is a true extract, and you do not know
where those documents are because they have gone into the Translation
Division? That is right, is it not?</p>
<p class="pindent">DR. HORN: Only partially, Mr. President. I know that I handed
in these documents, to the proper office, in German, and with
my signature. Then that office kept them and had them translated.
From the moment I handed them in I naturally have had no further
control of what happened.</p>
<p class="pindent">I may also point out that the document books which we used
were available only in a single copy and must be used by all
attorneys, even now, for their future work. Because of that,
I cannot produce the original for the Tribunal since it is not my
property. That can be done in agreement only with the person
in charge of the document section, Lieutenant Commander Schrader.</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, if, in the future, you and the
other defendants’ counsel could get your document books ready in
sufficient time, you could perhaps then make the arrangement that
you hand in the document book, when you are offering it in
evidence, and then it would be capable of being handed to the
officer of the Court.</p>
<p class="pindent">DR. HORN: Mr. President, I do not believe that that possibility
exists at all, for these <span class="it1">Dokumente der Deutschen Politik</span>—just to use
this example—are available only in one copy for the use of all
Defense Counsel attorneys; I cannot take these books away, if they
wish to continue work with them, in order to submit them to the
Tribunal as evidence. I would not receive them. I receive these
books only to use them, and make excerpts from them, and then
I have to return them.</p>
<p class="pindent">THE PRESIDENT: Yes, but you are putting in evidence now a
certain extract from the book, and all the Tribunal wants is that
that extract be certified, either by you or by some other person who
can be trusted, as a correct extract from the book, and that that
document, so signed, can be produced. It may be difficult to produce
it at the moment because you have handed it in to some official or
to somebody in the Translation Division and therefore you cannot
produce it, but it could be arranged that it should be produced in
the future. I do not mean this particular one, but in the future
other defendants’ counsel can produce their documents certified by
themselves or by some other person of authority.</p>
<p class="pindent">DR. HORN: That has already been done, Mr. President. Five
document books of the same type, signed by me, were handed to
the Tribunal.
<span id="Page_99" title="99"></span></p>
<p class="pindent">THE PRESIDENT: Yes. Well, the rule of the Tribunal happens
to be that they should be handed in, in this Court, at the time that
they are being used, as well as their being handed in to somebody
for the purpose of translation. That is the rule.</p>
<p class="pindent">But now perhaps we had better get on as we are taking up too
much time over this.</p>
<p class="pindent">DR. HORN: I have just heard that the German documents which
I signed are being procured from the Secretariat General, so I will
be able to submit them to the Tribunal with signature, in the
German.</p>
<p class="pindent">THE PRESIDENT: Very well.</p>
<p class="pindent">DR. HORN: I should like to continue and explain the afore-mentioned
opinion of the legal consequences of the Pact made between
France and Russia in 1936, and I refer to Page 3, that is, Page 8 of
the document book. I quote:</p>
<div class="blockquote">
<p class="calibre3">“Consequently, the only question is whether France, in accepting
these treaty obligations, has kept within those limits
which, in her relation to Germany have been laid on her by
the Rhine Pact.</p>
<p class="calibre3">“This, however, the German Government must deny.</p>
<p class="calibre3">“The Rhine Pact was supposed to achieve the goal of securing
peace in Western Europe by having Germany on the one
hand, and France and Belgium on the other, renounce for all
time employing military force in their relations to each other.
If, by the conclusion of the pact, certain reservations to this
renunciation of war, going beyond the right of self-defense,
were permitted, the political reason for this was, as is generally
known, solely the fact that France had already taken
on certain alliance obligations towards Poland and Czechoslovakia
which she did not want to sacrifice to the idea of
absolute peace security in the West. Germany at that time
accepted in good faith these reservations to the renunciation
of war. She did not object to the treaties with Poland and
Czechoslovakia, placed on the table at Locarno by the representative
of France, only because of the self-understood supposition
that these treaties adapted themselves to the structure
of the Rhine Pact and did not contain any provisions on the
application of Article 16 of the Covenant of the League of
Nations, such as are provided for in the new French-Soviet
agreements. This was true also of the contents of these special
agreements, which came to the knowledge of the German
Government at that time. The exceptions permitted in the
Rhine Pact did, it is true, not expressly refer to Poland and
Czechoslovakia, but were formulated generally. But it was
<span id="Page_100" title="100"></span>
the sense of all negotiations about this matter to find a compromise
between the German-French renunciation of war and
the desire of France to maintain her already existent pact
obligations. If, therefore, France now takes advantage of the
abstract formulation of war possibilities allowed for in the
Rhine Treaty in order to conclude a new pact against Germany
with a highly armed state, if thus in such a decisive
manner she limits the scope of the renunciation of war mutually
agreed upon with Germany, and if, as set forth above,
she does not even observe the stipulated formal juridical
limits, then she has created thereby a completely new situation
and has destroyed the political system of the Rhine Pact
both in theory and literally.”</p>
</div>
<p class="pindent">I will omit the next paragraph and will quote from Page 9 of
the document book as follows:</p>
<div class="blockquote">
<p class="calibre3">“The German Government have always emphasized during
the negotiations of the last years that they would maintain
and carry out all obligations of the Rhine Pact as long as the
other partners to the Pact also were willing on their part
to adhere to this Pact. This natural supposition cannot any
longer be regarded as fulfilled by France. In violation of the
Rhine Pact, France has replied to the friendly offers and
peaceful assurances, made again and again by Germany, with
a military alliance with the Soviet Union, directed exclusively
against Germany. Therefore the Rhine Pact of Locarno has
lost its inner meaning and has ceased to exist in any practical
sense. For that reason Germany also on her side does not
consider herself bound any longer by this pact which has
become void.”</p>
</div>
<p class="pindent">In consideration of the Franco-Russian pact and the intentions
of the French General Staff, Hitler had the Defendant Von Ribbentrop
come to him in order to question him about the presumable
attitude of England to a possible German reoccupation...</p>
<p class="pindent">THE PRESIDENT: You are reading from the document, are you
not, Dr. Horn? You begin to tell us something about Hitler.</p>
<p class="pindent">DR. HORN: Yes, I interrupted at the phrase “as bound by this
pact which has become void,” in order to bring in the role of
Ribbentrop briefly. On the basis of this pact and of the intentions
of the French General Staff, Hitler then had the Defendant
Von Ribbentrop...</p>
<p class="pindent">THE PRESIDENT: We shall hear that from Von Ribbentrop,
shall we not?</p>
<p class="pindent">DR. HORN: Mr. President, we are permitted to add a few connecting
words to the documents. I can now...
<span id="Page_101" title="101"></span></p>
<p class="pindent">THE PRESIDENT: Yes, Colonel Pokrovsky.</p>
<p class="pindent">COL. POKROVSKY: As far as I can understand, the Tribunal
has already explained to Ribbentrop’s Defense Counsel, Dr. Horn,
that the Defense is now submitting a document. Although Dr. Horn
does not consider it necessary to state when he deviates from the
document and when he quotes from it, I have had the opportunity
of noting that in the document he has just quoted, numbered
Ribbentrop-1, there is a complete absence of any reference to the
plans of the French General Staff. Among the documents in the
document book submitted by Ribbentrop’s Defense Counsel I could
not find any copies of the plans of the French General Staff. It is
therefore quite incomprehensible to me how Dr. Horn happens to be
informed about the plans of the French General Staff, and on what
grounds he refers to these plans while presenting evidence, in
Ribbentrop’s case, since they appear to be completely absent among
the documents to which he refers.</p>
<p class="pindent">DR. HORN: Mr. President...</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, what you appeared to the Tribunal
to be doing then was not anything explanatory of the document, but
telling us what Hitler did, and what the Defendant Ribbentrop did,
in consequence of what Hitler did. That is not in evidence. You
cannot tell us what is not in evidence. You can only give us
explanatory remarks to make the document itself intelligible.</p>
<p class="pindent">DR. HORN: Mr. President, the Defendant Von Ribbentrop is
accused on account of the conduct of the entire foreign policy. The
Prosecution have presented the foreign political activity as they see
it, and we have been permitted, not to give a speech, but, in connection
with the documents submitted, to present our opposing view,
as the Defense see it. In order to do that, I must refer to certain
facts, documents and quotations. I can never give a complete picture
if I may just submit a document without giving a large frame
to this matter, a certain development in the entire policy.</p>
<p class="pindent">THE PRESIDENT: Well, Dr. Horn, the Tribunal is not expecting
you to give a complete picture at this stage. All you are doing at
the present moment is introducing the evidence. You are going to
give the complete picture when you make your final speech. It is
intelligible, this document. It is a document which is well known;
it is perfectly intelligible without telling us what Hitler or what the
Defendant Ribbentrop did.</p>
<p class="pindent">DR. HORN: Regarding these questions raised by the Russian
Prosecutor, I have already asked for the Defendant Von Neurath
as a witness. I can interrogate him on this point only after the
Defendant Von Neurath is in the witness box. But I can still refer
now to these facts that are counterevidence.
<span id="Page_102" title="102"></span></p>
<p class="pindent">THE PRESIDENT: But, you see, that would be his function. If
you are going to tell us what you think the Defendant Von Neurath
is going to say in answer to questions which you put to him, that
would be making an opening statement. Well, that has not
been provided for by the Charter. We must wait until you call
Von Neurath or until you question Von Neurath.</p>
<p class="pindent">DR. HORN: Then I will read from this document just mentioned,
Ribbentrop Exhibit Number 1, on Page 10 of the document book:</p>
<div class="blockquote">
<p class="calibre3">“The German Government are now forced to face the new
situation created by this alliance, a situation which is made
more critical by the fact that the Franco-Soviet pact has found
its complement in a pact of alliance of exactly parallel nature
between Czechoslovakia and the Soviet Union. In the interest
of the elementary right of a nation to safeguard its borders
and to guarantee its defensive capacities, the German Government
have therefore re-established the full and unrestricted
sovereignty of the Reich in the demilitarized zone of the
Rhineland, effective today.”</p>
</div>
<p class="pindent">I ask the Tribunal to accept the entire document as evidence.
Through this step of the German Government certain articles of
the Treaty of Versailles which were concerned with the demilitarization
of the Rhineland zone had become obsolete. Since this morning,
by decision of the Court, the taking of a position on the Versailles
Treaty is not permitted, I will omit the corresponding material
from the document book of the Defendant Von Ribbentrop, and turn
now to the document Ribbentrop Exhibit Number 8, which is on
Page 21 of the document book.</p>
<p class="pindent">May I put another question first, Mr. President?</p>
<p class="pindent">THE PRESIDENT: Certainly.</p>
<p class="pindent">DR. HORN: Is it permitted to submit the official documents on
the Treaty of Versailles that were exchanged between governments
before the conclusion of the treaty? These are purely government
documents and not any arguments on the treaty itself. May these
documents be submitted after the decision of the Tribunal today?</p>
<p class="pindent">THE PRESIDENT: Which are they, the one on Page 21?</p>
<p class="pindent">DR. HORN: This is in regard to the Ribbentrop Exhibit Number 3.</p>
<p class="pindent">THE PRESIDENT: Where is that?</p>
<p class="pindent">DR. HORN: It is on Page 14 of the document book.</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, the Tribunal would like to know
what issue in this Trial this document is relevant to.</p>
<p class="pindent">DR. HORN: I wanted to explain by it the German opinion of the
Treaty of Versailles. Ribbentrop Exhibit Number 2 is the note of
Germany to the United States that contains the offer for an armistice
and conclusion of peace. And I wanted further to show in the
<span id="Page_103" title="103"></span>
next note again that this offer was one based on the Wilsonian
Fourteen Points. Further, with Ribbentrop Exhibit Number 4, I
wanted to submit evidence that the peace and the armistice were
to be concluded on the basis of the Fourteen Points with two exceptions.
I also wanted to show through Ribbentrop Exhibit...</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: My Lord, I tried not to interrupt,
but really this is the issue that the Tribunal ruled on a
fortnight ago when the Defendant Göring, I think, applied for
documents on exactly this issue; and that also, as I understand,
the Tribunal ruled on again this morning. The issue is perfectly
clear; the only issue to which this can be directed is whether the
Treaty of Versailles was in accordance with the Fourteen Points
and if not, was therefore an unjust treaty which comes directly
within the Tribunal’s ruling of an hour ago.</p>
<p class="pindent">DR. HORN: May I add something more?</p>
<p class="pindent">As far as I and my colleagues have understood the ruling of the
Tribunal today, the only prohibition is against making before this
Tribunal statements on the injustice of the treaty and on the fact
that it purportedly was concluded under duress. We have not understood
the decision in any other way.</p>
<p class="pindent">THE PRESIDENT: That was why I asked you to what issue this
was relevant, and you said that it was relevant to showing what the
German opinion on the treaty was. Well, these are documents of the
period before the treaty was made, and they seem to be only relevant
upon the question of whether or not the treaty was a just
treaty or not a just treaty.</p>
<p class="pindent">DR. HORN: I personally did not want to demonstrate through
this document either that it was a just or an unjust peace, but only
that it was a treaty which had many legal inadequacies, since the
main treaty was not in line with the agreements of the preliminary
treaty.</p>
<p class="pindent">THE PRESIDENT: Well, if the main treaty was not in accordance
with the preliminary treaty then the main treaty would, according
to that argument be an unfair treaty. That is the very point
upon which the Tribunal has ruled.</p>
<p class="pindent">DR. HORN: For that reason, Mr. President, I have just omitted
these documents also and said that I will not refer to them in view
of this ruling. I will now turn to Document Number 8.</p>
<p class="pindent">THE PRESIDENT: As you are going through a lot of documents
we might break off for 10 minutes.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00011">[<span class="it1">A recess was taken.</span>]</h3>
<p class="pindent"><span id="Page_104" title="104"></span></p>
<p class="pindent">MR. DODD: I do not want to take much of the Tribunal’s time,
but in view of the statement of Dr. Horn concerning the condition
of the Defendant Von Ribbentrop, I think it is required that we
inform the Tribunal of the situation as we understand it, which is
something quite different from the understanding of Dr. Horn.</p>
<p class="pindent">I have talked with Colonel Andrus and with one of the Army
doctors in attendance. Colonel Andrus has talked with both of them,
and our understanding is that Ribbentrop is not ill and is able to
take the witness stand; that he is nervous, and appears to be frightened,
but he is not disabled in any sense and is capable of testifying.</p>
<p class="pindent">DR. HORN: I come now to Page 21 of the document book, and
ask the Court to take judicial notice of the document appearing
under Ribbentrop Exhibit Number 8. It is a copy, again from the
<span class="it1">Dokumente der Deutschen Politik</span>, Volume 4, which I turned over,
signed, to the Court. It is the speech of Ambassador Von Ribbentrop
at the 91st session of the League of Nations Council in London,
regarding the Soviet Pact, the Locarno Pact and the German Peace
Plan. The speech was delivered on 19 March 1936. I refer to Page 3
of the speech and begin my quotation with Number 5. I quote:</p>
<div class="blockquote">
<p class="calibre3">“According to this alliance, France and Russia appoint themselves
judges on their own affairs by independently determining
the aggressor, if occasion arises without a resolution
or a recommendation of the League of Nations, and thereby
are able to go to war against Germany according to their own
judgment.</p>
<p class="calibre3">“This strict obligation of the two countries is clearly and
unequivocally evident from Paragraph 1 of the signatory
protocol to the Treaty of Alliance. That means: In a given
case France can decide, on her own judgment, whether Germany
or Soviet Russia is the aggressor. She merely reserves
the right not to be exposed, on account of military action
based on such an individual decision, to sanctions on the part
of the powers guaranteeing the Rhine Pact, namely, England
and Italy.</p>
<p class="calibre3">“From the point of view of law and realistic politics, this
reservation is meaningless.</p>
<p class="calibre3">“In terms of law: How will France be able to foresee, when
determining the aggressor herself, what attitude the guarantors
of the Locarno Pact will afterwards assume towards her
one-sided definition? The answer to the question of whether
France would have to fear sanctions in such a case depends
in practice not only on the faithful adherence to the pact by
the guarantors—about which the German Government do not
wish to raise doubts in any way—but also on the most various
prerequisites of a purely factual nature, the probability or
<span id="Page_105" title="105"></span>
improbability of which is not to be perceived in advance. In
addition, however, the evaluation of the relationship between
the new Treaty of Alliance and the Rhine Pact cannot be
made dependent on the treaty relationship between France
and Germany on the one hand and the Guaranteeing Powers
on the other, but only on the direct treaty relationship
between France and Germany themselves. Otherwise one
would have to expect Germany to tolerate silently every
possible violation of the Rhine Pact by France, in confidence
that the guarantors would have to provide for her security.
That certainly is not the intention of the Rhine Pact.</p>
<p class="calibre3">“In terms of realistic politics: When a country is attacked by
such a superior military coalition as a consequence of a decision,
incorrect because taken in advance in one of the party’s
own interests, it is an empty consolation to obtain its right
in subsequent sanctions against the aggressors condemned by
the League of Nations Council. For what sanctions could
actually hit such a gigantic coalition reaching from East Asia
to the Channel? These two countries are such powerful and
important members and especially militarily strong factors of
the League of Nations that according to all practical considerations,
sanctions would be unthinkable from the outset.</p>
<p class="calibre3">“Therefore this second reservation dealing with the consideration
of probable sanctions is of no consequence at all from
a realistic political point of view.</p>
<p class="calibre3">“I now ask the members of the Council to bear in mind not
only the legal and practical political scope of this obligation
of France’s to act independently, but to ask yourselves above
all whether the opinion can be advocated that the German
Government of that time, which signed the Locarno Pact,
would ever have taken upon themselves the obligations of
this Pact, had it contained such one-sided stipulations as have
now later developed.”</p>
</div>
<p class="pindent">I now go to Page 26 of the document book, and the same document,
and to clarify the German point of view, I add the following.
I quote:</p>
<div class="blockquote">
<p class="calibre3">“But the Franco-Soviet Russian alliance means, beyond that—in
the German Government’s view of history—a complete
elimination of the hitherto existing European balance and
consequently of the fundamental political and legal conditions
under which the Locarno Pact was concluded at that time.”</p>
</div>
<p class="pindent">With this, Germany had expressed the legal basis of her attitude
toward the Locarno Pact and the Versailles stipulations regarding
the demilitarization of the Rhineland. In order to prove her will
to disarm, there is in the same document on Page 7, that is, Page 27
<span id="Page_106" title="106"></span>
of the document book, an exhaustive and detailed disarmament
proposal.</p>
<p class="pindent">I ask the Tribunal to accept in evidence the document just cited,
so that I may later refer to it.</p>
<p class="pindent">With this exposition I conclude my presentation on Germany’s
reasons for reoccupying the Rhineland. Regarding the role of the
Defendant Von Ribbentrop in the occupation of the Rhineland, I
shall enter upon that when I call the Defendant to the witness stand.</p>
<p class="pindent">After the occupation of the Rhineland, the Defendant Von Ribbentrop
returned to London, where he was then ambassador. On
4 February 1938 he was appointed Foreign Minister, and from
that time on, conducted the foreign policy along the lines laid down
by Hitler. In proof of this statement I refer to Ribbentrop Exhibit
Number 10, to be found in the document book. This is a very short
document that I submit to the Tribunal for judicial notice. It is
an excerpt from the speech of the Führer before the German
Reichstag in the Kroll Opera House in Berlin on 19 July 1940.
I quote:</p>
<div class="blockquote">
<p class="calibre3">“I cannot conclude this appraisal without finally thanking the
man who for years has carried out my foreign political directions
in loyal, tireless, self-sacrificing devotion.</p>
<p class="calibre3">“The name of Party member Von Ribbentrop will be linked
for all time with the political rise of the German Nation as
that of the Reich Foreign Minister.”</p>
</div>
<p class="pindent">I submit this quotation to the Tribunal to show according to
what principles the Defendant Von Ribbentrop had to conduct the
foreign policy.</p>
<p class="pindent">I should like now to ask the Tribunal to hear the witness State
Secretary Von Steengracht.</p>
<p class="pindent">[<span class="it1">The witness Von Steengracht took the stand.</span>]</p>
<p class="pindent">THE PRESIDENT: Will you state your name, please?</p>
<p class="pindent">ADOLF FREIHERR STEENGRACHT VON MOYLAND (Witness):
Adolf von Steengracht.</p>
<p class="pindent">THE PRESIDENT: Will you repeat this oath after me: “I swear
by God—the Almighty and Omniscient—that I will speak the pure
truth—and will withhold and add nothing.”</p>
<p class="pindent">[<span class="it1">The witness repeated the oath in German.</span>]</p>
<p class="pindent">THE PRESIDENT: You may sit down if you wish.</p>
<p class="pindent">DR. HORN: What was your last position in the Foreign Office?</p>
<p class="pindent">VON STEENGRACHT: From May 1943 I was State Secretary
of the Foreign Office.</p>
<p class="pindent">DR. HORN: What were your activities?
<span id="Page_107" title="107"></span></p>
<p class="pindent">VON STEENGRACHT: In order to present my activities in a
comprehensible way, I must make the following prefatory remarks:</p>
<p class="pindent">From the beginning of the war, the Foreign Minister had his
office in the neighborhood of Hitler’s headquarters; that is to say
in most instances several hundred kilometers distant from Berlin.
There he carried on business with a restricted staff. The Foreign
Office in Berlin had duties of a routine and administrative nature.
But above all, its duty was also the execution of the regular intercourse
with foreign diplomats.</p>
<p class="pindent">Within the limits of this field of duties, I bore the responsibility,
as State Secretary, from May 1943. The molding of foreign
political opinion, the decisions and instructions in foreign policy,
on the other hand, originated from headquarters, mostly without
any participation, sometimes also without any subsequent information
to the Foreign Office.</p>
<p class="pindent">DR. HORN: Who determined the basic lines of the foreign policy?</p>
<p class="pindent">VON STEENGRACHT: The foreign policy, not only on its basic
lines, but also usually down to the most minute details, was determined
by Hitler himself. Ribbentrop frequently stated that the
Führer needed no Foreign Minister, he simply wanted a foreign
political secretary. Ribbentrop, in my opinion, would have been
satisfied with such a position because then at least, backed by
Hitler’s authority, he could have eliminated partly the destructive
and indirect foreign political influences and their sway on Hitler.
Perhaps he might then have had a chance of influencing Hitler’s
speeches, which the latter was accustomed to formulate without
Ribbentrop, even in the foreign political field.</p>
<p class="pindent">DR. HORN: Were there other offices or personalities, in addition
to the Foreign Office, that concerned themselves with foreign
policy?</p>
<p class="pindent">VON STEENGRACHT: Yes, there was practically no office in
the Party or its organizations that, after 1933, had no foreign
political ambitions. Every one of these offices had a sort of foreign
bureau through which it took up connections with foreign countries
in the attempt to gain its own foreign political channels.</p>
<p class="pindent">I should judge the number of these to be approximately thirty.
For example, the Hitler Jugend, the SA, the German Labor Front,
the SS, the Rosenberg office with its Foreign Political office, the
Propaganda Ministry, the office Waldeck, the Ribbentrop office, the
Nordic Society; further, the VDA, the German Academy, the Reich
Railways (Reichsbahn) and others. Besides these offices, the
immediate entourage of Hitler and personalities like Himmler,
Goebbels, and Bormann had an influence in the shaping of foreign
policy. Göring, too, as I see it, had perhaps a certain influence,
<span id="Page_108" title="108"></span>
but only until 1938—at any rate, in matters of foreign politics,
scarcely later than that.</p>
<p class="pindent">DR. HORN: Did Von Ribbentrop make efforts to prevent such
influences or to exclude them?</p>
<p class="pindent">VON STEENGRACHT: From my own observation, I can give
only the following judgment: Almost every one of those persons,
who had never before lived in foreign countries and who, as an
occasional traveling salesman for the Third Reich, in peacetime,
or after the occupation of a foreign country, had eaten well in the
capital of this or that foreign country, considered himself an
unrivaled expert on this country. They all had a predilection for
bringing their enlightenment and discernment to Hitler. Unfortunately
the further they were removed from actual conditions, the more
they were in contradiction to the political requirements and necessities,
and especially, unfortunately, the more so-called strength
was shown and the more they stood in contradiction to the elementary
feelings of humanity, the more they pleased Hitler. For Hitler
regarded such statements and representations as sound judgment,
and they had sometimes an irreparable effect, and formed in Hitler’s
mind, together with his so-called intuition, the start of some
fundamental idea. To the possible objection that it should have
been easy for an expert to criticize such an opinion or view, I
should like to point out the following: As long as the future
German Ambassador in Paris was still a teacher of painting, Hitler
read his reports with interest; but when he became the official
representative of the Reich, his reports were mostly thrown unread
into the wastepaper basket. Himmler’s reports, the slanted opinions
of Goebbels, and Bormann’s influence played, on the other hand,
a decisive role, as did reports from agents which could not be
checked and which carried more weight than the opinions of experts
on the countries.</p>
<p class="pindent">DR. HORN: Was the Foreign Office responsible for relations
with all foreign countries?</p>
<p class="pindent">VON STEENGRACHT: I should like to remark further here
that I have not yet answered the second part of your question,
namely, regarding the elimination of this influence.</p>
<p class="pindent">With Hitler’s methods of work, these so-called counterinfluences
simply could not be eliminated. Against this “organized disorganization”
Ribbentrop waged an unmitigating, bitter war, and that
against almost all German offices. I should like to state further
that at least 60 percent of his time was devoted to these things alone.</p>
<p class="pindent">DR. HORN: Was the Foreign Office responsible for the relations
with all foreign countries?</p>
<p class="pindent">VON STEENGRACHT: In peacetime, yes.
<span id="Page_109" title="109"></span></p>
<p class="pindent">DR. HORN: Did the position of the Foreign Office change with
the outbreak of war?</p>
<p class="pindent">VON STEENGRACHT: Yes. In point of fact, the Foreign Office
lost its competency toward the country concerned at the moment
when the German bayonet crossed the border. The exclusive right
to maintain direct relations with foreign governments was eliminated
in all occupied territories; in most instances even the right to have
a representative of the Foreign Office whose post was for observation
only and without competency. This is particularly true for
the Eastern Territories and for Norway.</p>
<p class="pindent">Where Ribbentrop made the effort to maintain, in spite of the
occupation, a certain degree of independence of a country, as, for
example, in Norway, this activity of our diplomats was termed
weak, traitorous, stupid, and those responsible had to stop their
work at once, on Hitler’s orders, and disappeared from the Foreign
Office.</p>
<p class="pindent">In general the changed position of the Foreign Office during the
war is best characterized by Hitler’s statement: “The Foreign Office
shall, as far as possible, disappear from the picture until the end
of the war.” Hitler wanted to limit the Foreign Office to about
20 to 40 people, and it was even partially forbidden to form or to
maintain any connection with the Foreign Office.</p>
<p class="pindent">The Foreign Office, as such, and its officials were detested by
Hitler. He considered them objective jurists, defeatists, and cosmopolitans,
to whom a matter can be given only if it is not to be
carried out.</p>
<p class="pindent">DR. HORN: Was there any foreign policy, in a traditional sense,
in Germany?</p>
<p class="pindent">VON STEENGRACHT: No; at least, I never noticed anything of
it, for Hitler had in effect made the statement: “Diplomacy is defrauding
the people. Treaties are childish; they are respected only
as long as they seem useful to the respective partners.” That was
Hitler’s opinion of all diplomats in the world.</p>
<p class="pindent">DR. HORN: Did the Foreign Office have any influence in the
Eastern territories and the territories that were under civilian
administration?</p>
<p class="pindent">VON STEENGRACHT: T have already touched on this question.
I have already said that in the territories in which there was a
military government or a civilian administration, a representative
of the Foreign Office—if he was tolerated at all—was tolerated
only as an observation post, at any rate had no functions; that was
the rule.</p>
<p class="pindent">I think I would be going too far if I went through the condition
in every country. The situations varied.
<span id="Page_110" title="110"></span></p>
<p class="pindent">DR. HORN: Do you consider Von Ribbentrop a typical National
Socialist or not?</p>
<p class="pindent">VON STEENGRACHT: Ribbentrop was, in his whole attitude, no
typical exponent of National Socialism. He knew extraordinarily
little of the dogma and doctrines of National Socialism. He felt himself
only personally bound to Hitler, whom he followed with soldierly
obedience, and he stood under a certain hypnotic dependence
on Hitler. However, I cannot characterize him as a typical exponent
of National Socialism.</p>
<p class="pindent">DR. HORN: Was Hitler a man who was accessible to suggestions
and objections?</p>
<p class="pindent">VON STEENGRACHT: In the first years after 1933 he is said
still to have been; but during the course of years he shut himself
off more and more from expert objections and suggestions. From
the time that I became State Secretary, I saw him only twice on
official occasions. I can thus speak only on the success or lack of
success of our work. In the course of my activities, covering almost
2 years, I can now recall almost no case in which he agreed to one
of our suggestions. On the contrary, it was always to be feared that
by some suggestion of a personal nature he would be led to take
violent action in an opposite direction. The basic trait of his character
was probably lack of confidence, and this bore unprecedented fruit.
Thus, experts and decent people who tried to influence Hitler to
their way of thinking were engaged, in my opinion, in an altogether
vain task. On the other hand, irresponsible creatures who incited
him to take violent measures, or who voiced their suspicions,
unfortunately found him extremely accessible. These men were
then termed strong, whereas the behavior of anyone who was even
halfway normal was condemned as weak or defeatist; through a
reasonable opinion voiced only once, the influence of that man could
be forever destroyed.</p>
<p class="pindent">DR. HORN: What conclusions did Hitler draw from contradictory
viewpoints in respect to the contradicting persons?</p>
<p class="pindent">VON STEENGRACHT: I cannot answer that question in general
terms. I have already shown it in my previous answers. First of
all the reaction depended very much, in my opinion, on the mood
of the Dictator at the time. It was also a matter of importance as
to who contradicted and how much strength or weakness he had
already shown or seemed to have shown. But what the atmosphere
was can perhaps be demonstrated by the following case, shortly
after the death of President Roosevelt, as told by Ribbentrop’s liaison
agent with Hitler, a man named Hewel. He said:</p>
<div class="blockquote">
<p class="calibre3">“Today I almost met my doom. Goebbels came from the
Führer, and reported on Germany’s prospects, as far as the
<span id="Page_111" title="111"></span>
Führer saw them affected by Roosevelt’s death, and he drew
up a very hopeful picture of the future. I, Hewel, was of the
opinion that such a view was not justified and remarked as
much cautiously to Goebbels. Goebbels fell into a rage, called
me a spirit who demoralized everyone, who trampled on the
happy moods and hopes of every decent person. I was forced,”
Hewel reports, “to make a special trip to see Goebbels and to
ask him to keep the matter to himself. For if he had informed
the Führer of my attitude, Hitler would have merely pressed
a button, and called Rattenhuber, the Chief of his Security
Service, and had me taken away and shot.”</p>
</div>
<p class="pindent">DR. HORN: How do you explain the fact that so many people
remained in Hitler’s circle, although they could not agree with him
on basic matters?</p>
<p class="pindent">VON STEENGRACHT: It is true that many people remained
in their positions although at heart they disapproved of Hitler’s
methods of government and, indeed, were inimical to those methods.
There are various reasons for this.</p>
<p class="pindent">First, it must be said that the NSDAP had come into power
according to the rules of parliamentary procedure as being the
strongest Party in the Reichstag. The officials employed had no
reason at all to retire from service on account of the change of
government. In consequence of the change to dictatorial government
and the completely different concept of the State which the
change of government involved, the individual suddenly found that
he was no longer allowed to take a position of his own concerning
this regime. The notorious reign of terror began. Everywhere, in
the ministries and chancelleries, in private dwellings, and in restaurants
there hovered spies who, out of fanaticism or for pay, were
willing to report everything they heard.</p>
<p class="pindent">Nevertheless, many would deliberately have risked the gravest
consequences, if their withdrawal could have in any way improved
anything. But it became obvious that such persons merely sacrificed
themselves and especially their families unavailingly, because cases
of the kind were painstakingly withheld from publicity and therefore
had no effect. Worst of all was the fact that the appointment
vacated was filled by an especially radical man. Many people
realized this and remained at their posts in order to prevent the
development that I have just described. The great number of
atrocities committed or ordered by Hitler or Himmler have led
many foreigners to the conclusion that the German people as a
whole shared the guilt for these crimes, or at least had knowledge
of them. This is not the case. The majority of people even in
high government positions did not learn details of these matters—or
the extent to which they were carried on—until the war was
<span id="Page_112" title="112"></span>
over. Perhaps the key to this is found in the speech which Himmler
delivered in Posen on 3 October 1943 to his Gruppenführer, and
which I learned of for the first time here. This speech directed
that his special assignments—that means the actions against the
Jews and the concentration camps—were to be kept just as secret
as had been the events of 30 June 1934, of which the German
people have only now learned the authentic story.</p>
<p class="pindent">Guilt for all these occurrences rests only on a relatively small
group, to be appraised at a few thousand people. It was these who
carried out this unparalleled terror against the German people. But
those who thought differently and who remained are chiefly to be
thanked for the fact that, for example, the Geneva Convention was
not renounced, that tens or even hundreds of thousands of English
or American airmen and prisoners were not shot, that the unfortunate
prisoners, those seriously wounded, were returned during the
war to their families in their home countries; Greece in her dire
need received food; exchange was stabilized as far as possible, as
in Belgium and France, and militarily pointless destruction ordered
in foreign countries and in the home country could be in part
prevented or at least lessened; indeed that the principles of human
justice, in some places at least, remained alive. These circles were
discouraged in their attitude earlier by the fact that no foreign
power had used the conditions in Germany as a reason for breaking
off diplomatic relations, but that almost all, until the outbreak of
war negotiated with National Socialism, concluded treaties and
even had their diplomatic representatives at the National Socialist
Party Days at Nuremberg. It was particularly noted that National
Socialist Germany, outwardly at any rate, received much more consideration,
understanding, and respect from foreign countries than
ever had the Weimar Republic despite all its fidelity to treaties or
its integrity.</p>
<p class="pindent">Then the war came, and with it special duties for civil servants,
officers, and every individual German. Should, and if so when and
how could these people who still felt themselves to be the servants
of the nation, leave their posts under these circumstances? Would
they, above all, by taking such a step be useful to their country
and to humanity? Would they have frightened Hitler or even
warned him?</p>
<p class="pindent">DR. HORN: Did you make peace suggestions of a foreign political
nature to Von Ribbentrop after the French campaign?</p>
<p class="pindent">VON STEENGRACHT: Yes. I had at that time, to be sure, no
official position. But I nevertheless felt the need, and I believe it
was a heartfelt wish of many, if not all, Germans, to see peaceful
conditions again in the world as soon as possible. On the day of
the capitulation of the King of the Belgians, I suggested:
<span id="Page_113" title="113"></span></p>
<p class="pindent">Firstly, the creation of a United States of Europe on a democratic
basis. This would have meant independence of Holland, Belgium,
Poland, and so on.</p>
<p class="pindent">Secondly, if this could not be brought about with Hitler, at any
rate to have as few encroachments on the autonomy of the countries
as possible.</p>
<p class="pindent">DR. HORN: Did Von Ribbentrop speak to Hitler on this matter?</p>
<p class="pindent">VON STEENGRACHT: So far as I know, yes. But at that time
Hitler considered such plans as premature.</p>
<p class="pindent">DR. HORN: Did you speak to Von Ribbentrop again in the winter
of 1942-43 on the same subject?</p>
<p class="pindent">VON STEENGRACHT: Yes. Ribbentrop at that time also worked
out very concrete proposals. They provided for the sovereignty and
independence of all conquered countries, including Poland, and in
addition, a far-reaching economic collaboration.</p>
<p class="pindent">DR. HORN: How did Hitler react then to these proposals?</p>
<p class="pindent">VON STEENGRACHT: Hitler turned down these proposals giving
as reason the fact that the time was not suitable, the military situation
not favorable enough, that this would be interpreted as a sign
of weakness.</p>
<p class="pindent">DR. HORN: Now to another question. Before the outbreak of the
Russian campaign, did Von Ribbentrop mention to Hitler Bismarck’s
statement about the danger of preventive wars?</p>
<p class="pindent">VON STEENGRACHT: Ribbentrop told me several times that
he was very concerned about the pact with Russia. In regard to
preventive war, he had stated to Hitler: “The good God does not
let anyone look at His cards.” I know too that Ribbentrop made
efforts to bring our experts on Russia to Hitler in order to explain
to him the situation there and to advise him against a war. Hitler
did not permit these people to see him, so far as I know. Only
Ambassador Count Schulenburg was granted a short audience. He,
who considered such a war ill-advised and emphatically rejected
the idea, could not, however, advance his views on Russia and the
reasons against a war; for Hitler, having delivered a speech of his
own on this subject, after about 20 minutes dismissed him abruptly
without letting him speak a word.</p>
<p class="pindent">THE PRESIDENT: Dr. Horn, the order of the Tribunal was that
witnesses might refresh their memory by notes, but this witness
appears to the Tribunal to have read practically every word he has
said. That is not refreshing your memory with notes. That is
making a speech which you have written out beforehand, and if
that sort of thing goes on the Tribunal will have to consider whether
it is necessary to alter its rule and adhere to the ordinary rule,
<span id="Page_114" title="114"></span>
which is that no witness is allowed to refer to any notes at all
except those made at the time.</p>
<p class="pindent">DR. HORN: Mr. President, to be sure, I discussed the questions
with the witness; but his notes, if they have been made, were made
by the witness independently and without my knowledge of the
exact contents. I shall now ask the witness to answer my questions
without making use of any means which I do not know. I do not—that
I want to emphasize once again—know these answers.</p>
<p class="pindent">Witness, is it known to you that Von Ribbentrop tried to use his
influence with Hitler to stop the damaging tendencies against the
Church and the Jews?</p>
<p class="pindent">VON STEENGRACHT: Yes. I know that Ribbentrop spoke frequently
with Hitler on this theme. I was absolutely in despair about
the policy toward the Church and the Jews, and for this reason had
occasion to speak to him about it often, as I have said. But he
explained to me again and again when he returned from Hitler:
“Hitler cannot be spoken to on this point. Hitler says that these
problems have to be solved before he dies.”</p>
<p class="pindent">DR. HORN: Did Von Ribbentrop and the Foreign Office have any
knowledge of the military planning?</p>
<p class="pindent">VON STEENGRACHT: Ribbentrop frequently told me that he
was completely in the dark in military affairs. So far as the Foreign
Office was concerned, it had no ideas whatever of strategic planning.</p>
<p class="pindent">DR. HORN: What were the relations between Ribbentrop,
Himmler, Goebbels, and Bormann?</p>
<p class="pindent">VON STEENGRACHT: The relations between Ribbentrop and
the aforenamed gentlemen were as bad as can be imagined. There
was a perpetual fight between them. In my opinion Ribbentrop
would have been Himmler’s first victim if anything had happened
to Hitler. A constant struggle and feud, I should like to state,
went on between these men with an exceptionally sharp exchange
of letters.</p>
<p class="pindent">DR. HORN: What was the relationship in general between the
highest Party and Reich offices?</p>
<p class="pindent">VON STEENGRACHT: The relationship in the individual departments
naturally varied according to the character and the origin of
the department chiefs. But one can say that the relationship was
bad throughout, and, especially, that reciprocal information, so
urgently necessary for state business, practically never developed.
It was almost more difficult for one minister to discuss a question
with another minister by telephone than to have had the Angel
Gabriel himself come from heaven and speak with one of us. Even
on the most important and essential matters, a factual discussion
<span id="Page_115" title="115"></span>
could not take place. There was, in other words, practically no
connection between these departments. Moreover, they were very
different, both in their character and in their ideas.</p>
<p class="pindent">DR. HORN: Is anything known to you about objections on the
part of the Vatican, above all regarding the Polish clergy?</p>
<p class="pindent">VON STEENGRACHT: I heard about that later, and there must
have been two protests concerning the Catholic Polish clergy. These
two notes were submitted by the Nuncio to the State Secretary of
that time. The then State Secretary turned these over to Ribbentrop
according to regulation, and Ribbentrop in his turn presented them
to Hitler. Since the Vatican had not recognized the Government
General, and accordingly the Nuncio was not competent for these
regions, Hitler declared when these notes were presented to him:</p>
<div class="blockquote">
<p class="calibre3">“They are just one blunt lie. Give these notes back to the
Nuncio through the State Secretary in a sharp form, and tell
him that you will never again accept such a matter.”</p>
</div>
<p class="pindent">DR. HORN: Were these notes then dealt with by the Foreign
Office?</p>
<p class="pindent">VON STEENGRACHT: Sharp and precise instructions were then
issued that in all cases in which representatives of countries brought
up matters which were not within their authority, whether in conversations,
or notes, <span class="it1">note verbale</span>, memoranda, or other documents,
these were not to be accepted, and verbal protests were to be turned
down sharply.</p>
<p class="pindent">DR. HORN: Is it known to you that Von Ribbentrop prevented
the shooting of about 10,000 prisoners of war after the terrible air
attack on Dresden?</p>
<p class="pindent">VON STEENGRACHT: Yes, I know the following: Von Ribbentrop’s
liaison man with Hitler called me up one day in great excitement.
He informed me that on a suggestion by Goebbels, the Führer
intended, as reprisal for the holocaust of Dresden, to have English
and American prisoners of war—I believe mostly airmen—shot. I
went immediately to Ribbentrop and informed him of this. Ribbentrop
became very excited; he turned pale as death; he was in fact
almost stunned and thought it was impossible; picked up the phone
and called up this liaison man in person in order to verify this
report. The liaison man corroborated it. Then Ribbentrop got up
immediately and went to Hitler, came back, I think after half an
hour, and told me that he had succeeded in having Hitler withdraw
this order. That is all I know about this matter.</p>
<p class="pindent">DR. HORN: Do you know anything about the convocation of an
anti-Jewish congress?</p>
<p class="pindent">VON STEENGRACHT: Regarding the convocation of an anti-Jewish
congress I know something; I believe our liaison man with
<span id="Page_116" title="116"></span>
Hitler informed us that, on a suggestion of Bormann, Hitler had
ordered the calling of an anti-Jewish congress through the Rosenberg
office. Ribbentrop did not want to believe this; but nevertheless
had to accept this too as true, once he had spoken with our
liaison man. Then, since on the basis of this decision we could do
nothing more officially to prevent the thing, we nevertheless worked
our way into it, and we made efforts by a policy of hesitation, delay,
and obstruction to render the convocation impossible. And although
the order was given in the spring of 1944 and the war did not end
until April 1945, this congress never actually took place.</p>
<p class="pindent">DR. HORN: Could you observe whether Von Ribbentrop often
adopted a stern manner with his staff, for reasons of state, although
he sometimes thought entirely differently?</p>
<p class="pindent">VON STEENGRACHT: This would be passing a judgment. But
I believe that I must affirm this: Thinking that he was being loyal
to Hitler, Ribbentrop—it seems to me—in those cases when he went
to Hitler with a preconceived opinion and returned with a totally
different view, tried afterwards to explain to us Hitler’s view. This
he always did with special vehemence. I would assume then that
this was contrary to his own most personal original ideas.</p>
<p class="pindent">DR. HORN: Did Von Ribbentrop during the course of the war
ask that Rome and Florence be spared?</p>
<p class="pindent">VON STEENGRACHT: So far as I know, yes. He did speak
with Hitler on these subjects.</p>
<p class="pindent">DR. HORN: Are you acquainted with an article by Goebbels in
the <span class="it1">Reich</span>, or perhaps the <span class="it1">Völkischer Beobachter</span>, dealing with lynch
justice?</p>
<p class="pindent">VON STEENGRACHT: Yes. Once by chance I came to Ribbentrop
when he was reading a paper and was again very excited. He
asked me if I had read the article yet, this shocking article by
Goebbels. It was an article on lynch justice.</p>
<p class="pindent">DR. HORN: Did Von Ribbentrop lodge a protest with Goebbels
about this article?</p>
<p class="pindent">VON STEENGRACHT: As far as I know, he charged our press
chief who had the liaison with Goebbels to lodge a protest against
this article. But to his surprise he was forced to see that this protest
was useless since the article had not only been inspired but, I
believe, ordered by Hitler, and thus there was nothing more to
be done.</p>
<p class="pindent">DR. HORN: What attitude did the Foreign Office take in view
of the trend of this article?</p>
<p class="pindent">VON STEENGRACHT: The Foreign Office repudiated the article
vehemently, because it comprised an offense against international
<span id="Page_117" title="117"></span>
law and thus made us depart from international law in another
field. Moreover, it appealed to the lower instincts of man, and both
in internal and external policy did great damage.</p>
<p class="pindent">Besides, such an article, that has been read by several hundred
thousands or by millions, does irreparable damage anyway. We
therefore insisted that under no circumstances should such things
appear in the press again. I must regretfully state, however, that
we had a very difficult stand in this matter, especially since low-flying
enemy craft often shot peasants in the fields and pedestrians
in the streets, that is to say, purely civilian people, with their murder
weapons. And our arguments that in our field we wanted to observe
international law under all circumstances, were not taken into
account at all either by most German officers, or above all by Hitler
personally. On the contrary, in this case too we were regarded
again only as formal jurists. But later we did try, as much as we
could, with the help of military offices, to prevent the carrying out
of this order.</p>
<p class="pindent">DR. HORN: Do you know of a Battalion Günsberg?</p>
<p class="pindent">VON STEENGRACHT: I do not know of a Battalion Günsberg.
I know, of course, of a former Legation Counsellor Von Günsberg
in the Foreign Office. This Legation Counsellor Von Günsberg
received, as far as I recall—I did not at that time do any work
at all connected with these matters—received from Ribbentrop the
assignment of following, with a few people from the Foreign Office
and a few drivers, the fighting troops, and seeing to it that, firstly,
the foreign missions, for instance in Brussels and Paris, and so
forth, that stood under the protection of the protective powers,
should not be entered by our troops. And at the same time Günsberg
was charged with protecting the files in the Foreign ministries that
were of foreign political interest.</p>
<p class="pindent">After the conclusion of the French campaign, Günsberg, as far
as I recall, was no longer in the active service of the Foreign Office,
but was listed with the Secret Field Police, from which he had
received a uniform, because as a civilian he could not enter these
countries.</p>
<p class="pindent">DR. HORN: How and when did Günsberg’s job end?</p>
<p class="pindent">VON STEENGRACHT: Ribbentrop lost interest after these events
in Günsberg and the original assignment. Then, after the beginning
of the Russian campaign, Günsberg, so far as I remember, reported
again for duty and said that he intended to do the same thing in
the East, and Ribbentrop told him:</p>
<div class="blockquote">
<p class="calibre3">“Yes, that is very good. You may go with a few people to
the army groups and see whether anything of interest for us
is happening there and also see to it that when we approach
<span id="Page_118" title="118"></span>
Moscow the foreign embassies <span class="it1">et cetera</span> are not entered, and
that the documents are preserved.”</p>
</div>
<p class="pindent">But he did not consider himself any longer as belonging to the
Foreign Office and apparently received orders from other offices.
Then, as I later heard, he had a large number of men under him
and had many automobiles which he could not have received from
the Foreign Office any more than he could have received a military
uniform from the Foreign Office so he was apparently working for
other offices.</p>
<p class="pindent">DR. HORN: He no longer belonged to the Foreign Office at any
rate not in a military capacity?</p>
<p class="pindent">VON STEENGRACHT: No. And, in addition, when Ribbentrop
heard that he had undertaken such a large job, he charged me personally
to call immediately on the SS and say that he, Ribbentrop,
did not want to have Günsberg any longer, and at that time I told
Obergruppenführer Wolff that I should like to point out that we
wanted nothing more to do with Günsberg. See to it that you keep
him with the Waffen-SS along with all his subordinates. That is
all I know about the matter of Günsberg.</p>
<p class="pindent">DR. HORN: Would Your Lordship like to interrupt the examination
or should I continue to put further questions?</p>
<p class="pindent">THE PRESIDENT: Unless you are going to conclude almost
immediately, we had better adjourn. Will you be some time longer
with this witness?</p>
<p class="pindent">DR. HORN: I have a number of further questions.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00012">[<span class="it1">The Tribunal adjourned until 27 March 1946 at 1000 hours.</span>]</h3>
<div class="calibre2"><span id="Page_119" title="119"></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?014901f6